
  import { Popup, Picker } from 'vant';
  import { computed, toRefs, ref, watch } from 'vue';
  import 'vant/es/popup/style';
  import 'vant/es/picker/style';
  import { SelectOptions, SelectOpts } from '../typings';

  type E = SelectOptions | SelectOptions[];

  export default {
    name: 'BaseSelect',
    components: { Popup, Picker },
    props: {
      modelValue: {
        type: [String, Array],
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      options: {
        type: Array as PropType<SelectOptions[]>,
        default: () => [],
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['change', 'update:modelValue'],
    setup(props, { emit }) {
      const { modelValue, options, disabled } = toRefs(props);
      const show = ref(false);
      const defaultIndex = ref(0);
      const isPlaceholder = computed(() => modelValue.value == '');
      const selectText = ref(modelValue.value);
      watch([options, modelValue], () => initSelectText());
      watch(options, () => {
        defaultIndex.value = 0;
      });

      function initSelectText() {
        let text = modelValue.value;
        if (Array.isArray(modelValue.value)) {
          text = formatText(modelValue.value, options.value);
        } else if (modelValue.value != '') {
          text = options.value.find((e) => e.value == modelValue.value)?.text || modelValue.value;
        }
        selectText.value = text;
      }

      function formatText(modelValue: string[], tree: SelectOptions) {
        const result: string[] = [];
        const loop = (values: string[], list: SelectOptions, index = 0) => {
          if (values[index]) {
            const value = values[index];
            const obj = list.find((e) => e.value == value) as SelectOpts;
            if (obj) {
              result.push(obj.text);
              if (obj.children) {
                loop(values, obj.children, index + 1);
              }
            }
          }
        };
        loop(modelValue, tree);
        return result.join('/');
      }

      function showPopup() {
        if (!disabled.value) {
          show.value = true;
        }
      }

      function hidePopup() {
        show.value = false;
      }

      function handlePickerConfirm(e: E) {
        if (Array.isArray(e)) {
          const textResult: string[] = [];
          const valueResult: Array<string | number> = [];
          for (let index = 0; index < e.length; index++) {
            const it = e[index] as SelectOpts;
            textResult.push(it.text);
            valueResult.push(it.value);
          }
          emit('update:modelValue', valueResult);
          emit('change');
          hidePopup();
        } else {
          if ((e as SelectOpts) && (e as SelectOpts).value) {
            hidePopup();
            emit('update:modelValue', (e as SelectOpts).value);
            emit('change');
            const index = options.value.findIndex((it) => it.value == (e as SelectOpts).value);
            defaultIndex.value = index == -1 ? 0 : index;
          }
        }
      }

      watch(modelValue, () => {
        if (!modelValue.value) {
          selectText.value = '';
        }
      });

      initSelectText();

      return {
        showPopup,
        handlePickerConfirm,
        hidePopup,
        isPlaceholder,
        show,
        selectText,
        defaultIndex,
      };
    },
  };
